import { LoopingCarousel } from '@cinch-nx/shared-ui'
import { SbBlokData } from '@storyblok/react'
import styles from './marketing-carousel.module.css'

interface MarketingCarouselProps {
  slides: SbBlokData[]
  slideSpeedInSeconds?: number
  shouldLoop?: boolean
}

export default function MarketingCarousel({
  slides = [],
  slideSpeedInSeconds = 2,
  shouldLoop = true,
}: MarketingCarouselProps) {
  if (slides.length === 0) {
    return null
  }

  return (
    <LoopingCarousel
      slideSpeedInSeconds={slideSpeedInSeconds}
      shouldLoop={shouldLoop}
      className={{
        carousel: styles.carousel,
        carouselSlide: styles.carouselSlide,
        controlsWrapper: styles.controlsWrapper,
        customPagination: styles.customPagination,
      }}
    >
      MarketingCards
    </LoopingCarousel>
  )
}
